exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HistoryEvents-HistoryEventsFilterbox-column_superior{width:33%;background:#fff}.HistoryEvents-HistoryEventsFilterbox-column_softener{width:15%;background:#fff}.HistoryEvents-HistoryEventsFilterbox-Table_container{width:100%;border-spacing:0;border-collapse:collapse}.HistoryEvents-HistoryEventsFilterbox-table_border{padding:10px}.HistoryEvents-HistoryEventsFilterbox-header{color:#0376a3}.HistoryEvents-HistoryEventsFilterbox-spirotech{background:#fae03a;color:#000}", ""]);

// exports
exports.locals = {
	"column_superior": "HistoryEvents-HistoryEventsFilterbox-column_superior",
	"column_softener": "HistoryEvents-HistoryEventsFilterbox-column_softener",
	"Table_container": "HistoryEvents-HistoryEventsFilterbox-Table_container",
	"table_border": "HistoryEvents-HistoryEventsFilterbox-table_border",
	"header": "HistoryEvents-HistoryEventsFilterbox-header",
	"spirotech": "HistoryEvents-HistoryEventsFilterbox-spirotech"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/HistoryEvents/HistoryEventsFilterbox.css
// module id = 1097
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20